/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type GetCBQResultResponse = {
  statusCode?: number;
  error?: ApiError | null;
  // Shape is server-defined; render defensively on the page.
  data?: any;
};

// GET /cbq/sessions/:cbqSessionId/result — final score / result for a
// submitted session. Idempotent.
export const GetCBQResult = async (
  cbqSessionId: string
): Promise<GetCBQResultResponse> => {
  try {
    const response = await axios.get(`/cbq/sessions/${cbqSessionId}/result`);
    return { data: response.data?.data ?? response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
